export enum FormConsigneeInformationFormValues {
    consigneeId = "entityID",
    consigneeName = 'entityName',
    consigneeEmail = 'email',
    consigneePhone = 'phone',
    consigneeFax = 'fax',
    consigneeTaxId = 'taxId',
    consigneeAddress1 = 'address1',
    consigneeAddress2 = 'address2',
    consigneeCity = 'city',
    consigneeCountry = 'country',
    consigneeZone = 'zone',
    consigneePostalCode = 'postalCode',
}

export const formConsigneeInformationInitialValues = {
    [FormConsigneeInformationFormValues.consigneeName]: '',
    [FormConsigneeInformationFormValues.consigneeEmail]: '',
    [FormConsigneeInformationFormValues.consigneePhone]: '',
    [FormConsigneeInformationFormValues.consigneeFax]: '',
    [FormConsigneeInformationFormValues.consigneeTaxId]: '',
    [FormConsigneeInformationFormValues.consigneeAddress1]: '',
    [FormConsigneeInformationFormValues.consigneeAddress2]: '',
    [FormConsigneeInformationFormValues.consigneeCity]: '',
    [FormConsigneeInformationFormValues.consigneeCountry]: '',
    [FormConsigneeInformationFormValues.consigneeZone]: '',
    [FormConsigneeInformationFormValues.consigneePostalCode]: '',
}